import { gql } from "@apollo/client";

export const UPLOAD_PRODUCT_NOTE_IMAGE_GQL = gql`
    mutation uploadProductNoteImage($input: UploadProductNoteImageInput!) {
        uploadProductNoteImage(input: $input) {
            url
            success
            message
        }
    }
`;
